import { IControl } from '@se/cp.common';
import { CpControl } from './cp-control';

export class CpUnknownControl extends CpControl {
    readonly controlTypeGroup = 'Unknown';

    constructor(control: IControl, _?: unknown) {
        super(control);
    }

    canAlignToBottom() {
        return true;
    }

    getHeightHint() {
        return 0;
    }
}
